<template>
    <el-dialog width="800px" title="添加产品" :before-close="handleClickCancel" class="region_dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="regionAddVisible" append-to-body>
            <div class="region_add_wrap">
                <div class="region_add_left">
                    <div class="category">
                        <div class="category_top" :class="{'active':groupingId == ''}" @click="handleClickGroupingItem({id:0})" >
                            <p>全部产品</p>
                        </div>
                        <div class="category_bottom" :class="{'noActiveTree':groupingId == ''}">
                            <el-tree ref="cateGoryTreeRef"
                                     :data="groupingList"
                                     :draggable="true"
                                     :expand-on-click-node='false'
                                     :props="{children: 'children',label: 'name'}"
                                     @node-click="handleClickGroupingItem"
                                     check-on-click-node
                                     check-strictly
                                     default-expand-all
                                     node-key="id">
                                <div  class="custom_tree_node" slot-scope="{ node, data }">
                                    <div  class="node_label single-line">{{node.label }}</div>
                                </div>
                            </el-tree>
                        </div>
                    </div>
                </div>
                <div class="region_add_right">
                    <div class="search_wrap">
                        <el-input size="small" v-model="keyword" placeholder="请输入想搜索的内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                            <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                        </el-input>
                    </div>
                    <div class="table_wrap" ref="table_wrap">
                        <el-table class="custom_table" :data="tableData" border  @selection-change="handleSelectionChange"    row-key="goods_id" :height="tableHeight" ref="multipleTable" >
                            <el-table-column align="center" type="selection"  reserve-selection width="50" :selectable="disableSelection"></el-table-column>
                            <el-table-column label="产品名称" prop="goods_name"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination_wrap">
                        <el-pagination background
                                       size="mini"
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="pagination.pageNum"
                                       :page-sizes="pagination.pageSizes"
                                       :page-size="pagination.pageSize"
                                       :layout="pagination.layout"
                                       :pager-count="5"
                                       :total="pagination.total">
                        </el-pagination>
                    </div>
                    <div class="btns_wrap">
                        <el-button type="" size="small" @click="handleClickCancel">取消</el-button>
                        <el-button type="primary" size="small" @click="handleClickConfirm">提交</el-button>

                    </div>
                </div>
            </div>
    </el-dialog>
</template>
<script>
import {GoodsCategoryList,GoodsPartGoodsList} from '@/api'
import {pagination} from "@/mixins";
import {getTableHeight} from "@/utils"
export default {
    name: 'region_add',
    props: {
        regionAddVisible: {
            type: Boolean,
            default: false,
        },
        selectedData: {
            type: Array,
            default: () => [],
        }, //当前已选产品
        productIds: {
            type: Array,
            default: () => [],
        },

    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            groupingId:'',
            groupingList:[],
            keyword:'',
            tableData:[],
            tableHeight:0,
            multipleSelection:[],
            activeType:''

        }
    },
    mixins: [pagination],
    created() {
       this.$nextTick(() => {
           this.tableHeight = this.$refs.table_wrap.offsetHeight
       })
       this.getGoodsCategoryList()
       this.getTableData()
    },
    computed: {

    },
    mounted() {
        this.$nextTick(() => {
            if(this.selectedData && this.selectedData.length>0){
                this.multipleSelection = this.selectedData
                this.activeType = this.selectedData[0].type
                this.multipleSelection.forEach(item => {
                    this.$refs.multipleTable.toggleRowSelection(item, true);
                })
            }
        })
    },
    methods: {
        // 点击分组
        handleClickGroupingItem(item){
            this.groupingId = item.id
            this.handleClickSearch()
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },

        // 获取产品分组
        getGoodsCategoryList(){
            let postData = {keyword:''}
            GoodsCategoryList(postData).then(res => {
                if (res.code === 200) {
                    this.groupingList = res.data
                }
            })
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                category_id:this.groupingId ? this.groupingId : '',
                keyword:this.keyword
            }
            this.loading = true
            GoodsPartGoodsList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        handleSelectionChange(val){
            if(val && val.length>0){
                this.activeType = val[0].type
            }else{
                this.activeType = ''
            }
            if(this.activeType == 'basic'){
                this.multipleSelection = [val[val.length-1]];
            }else{
                this.multipleSelection = val;
            }

        },
        // 产品禁用选择
        disableSelection(row){
            // 选择了行业标准产品就不能再选择产品了，除非取消了
            // 选择了别的类型的产品就不能选择行业标准产品了。
            if(this.activeType){
                if(this.activeType == 'basic'){
                    return  (this.multipleSelection && row.goods_id == this.multipleSelection[0].goods_id) ? true : false // row.type != 'basic' ?  false : true
                }else if(this.activeType != 'basic'){
                    return row.type == 'basic' ? false  : true
                }
            }else{
                return  true
            }
        },
        // 提交
        handleClickConfirm(){
            console.log(this.multipleSelection);
            this.$emit('success',this.multipleSelection)
            this.handleClickCancel()
        },
        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:regionAddVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>
::v-deep th .el-checkbox{
    display: none;
}
@import "@/styles/product_shelves.scss";
</style>
